<template>
  <div class="home">
    <div class="banner">
      <div class="home-width">
        <div class="title">{{ staticData.home.banner.title }}</div>
        <div class="des" v-html="staticData.home.banner.des"></div>
        <SafieButton
          v-if="!isLogin"
          type="second"
          size="large-52"
          :width="240"
          @click="router.push(staticData.home.banner.btn.router)"
          >{{ staticData.home.banner.btn.text }}</SafieButton
        >
      </div>
      <div class="lottie-box">
        <div class="down" ref="lottieRef"></div>
      </div>
    </div>
    <div class="guide">
      <div class="home-title">{{ staticData.home.guide.title }}</div>
      <div class="home-sub-title">
        {{ staticData.home.guide.subTitle }}
      </div>
      <div class="guide-bg">
        <img :src="staticData.home.guide.img" />
        <div class="btn-group flex justify-space-between">
          <SafieButton
            size="large-52"
            :width="240"
            @click="router.push(staticData.home.guide.methodBtn.router)"
            >{{ staticData.home.guide.methodBtn.text }}</SafieButton
          ><SafieButton
            size="large-52"
            :width="240"
            @click="router.push(staticData.home.guide.guideBtn.router)"
            >{{ staticData.home.guide.guideBtn.text }}</SafieButton
          >
        </div>
      </div>
    </div>
    <div class="case">
      <div class="home-title">{{ staticData.home.case.title }}</div>
      <div class="home-sub-title">
        {{ staticData.home.case.subTitle }}
      </div>
      <div class="carousel home-width">
        <div class="prev Safieicon" @click="handleChangeCase('prev')">
          &#xe63a;
        </div>
        <div class="next Safieicon" @click="handleChangeCase('next')">
          &#xe639;
        </div>
        <div class="carousel-box">
          <div
            class="flex"
            :style="{ left: `-${currenCase * 386}px`, transition: 'left 1s' }"
          >
            <div
              class="box"
              v-for="(item, index) in caseData"
              :key="index"
              @click="router.push(caseBaseRoute + item.id)"
            >
              <div class="case-image-box">
                <img :src="item.home_image" />
                <div class="image-hover-mask"></div>
              </div>
              <div class="title" v-html="item.title"></div>
              <div
                class="tag"
                v-for="(tag, tagIndex) in item.apis"
                :key="tagIndex"
              >
                {{ tag }}
              </div>
              <div class="company">
                {{ item.company.info[0].name
                }}{{ t("global.COMPANY_NAME_SUFFIX") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center">
        <SafieButton
          size="large-52"
          :width="240"
          @click="router.push(staticData.home.case.btn.router)"
        >
          {{ staticData.home.case.btn.text }}</SafieButton
        >
      </div>
    </div>
    <div class="qa">
      <div class="home-title">{{ staticData.home.qa.title }}</div>
      <div class="home-sub-title">
        {{ staticData.home.qa.subTitle }}
      </div>
      <div
        class="qa-item flex justify-space-between home-width align-center"
        v-for="(item, index) in faqShowData"
        :key="index"
        @click="handlerQaItem(index)"
      >
        <div class="item">
          <div class="ques">{{ item.question }}</div>
          <div class="tag">
            {{ item.category1 }}{{ t("global.HOME_FAQ_STATUS_SUFFIX") }}
          </div>
        </div>
        <div class="Safieicon">&#xe637;</div>
      </div>
      <div class="flex justify-center margin-top-64">
        <SafieButton
          size="large-52"
          :width="240"
          @click="router.push(staticData.home.qa.btn.router)"
        >
          {{ staticData.home.qa.btn.text }}</SafieButton
        >
      </div>
    </div>
    <div class="note">
      <div class="home-title">{{ staticData.home.note.title }}</div>
      <div
        v-for="(listItem, listIndex) in releaseData?.slice(0, 3)"
        :key="listIndex"
        class="note-item home-width"
      >
        <div class="time-tag flex align-center">
          <span></span>
          <div class="time align-center justify-center">
            {{ listItem.release_date }}
          </div>
        </div>
        <div v-html="listItem.note"></div>
        <div></div>
      </div>
      <div class="flex justify-center margin-top-64">
        <SafieButton
          size="large-52"
          :width="240"
          @click="router.push(staticData.home.note.btn.router)"
        >
          {{ staticData.home.note.btn.text }}</SafieButton
        >
      </div>
    </div>
    <div class="banner-10th">
      <a href="https://safie.co.jp/10th/" target="_blank">
        <div class="pc"><img src="../static/home/image/10th_wide.png" /></div>
        <div class="sp">
          <img src="../static/home/image/10th_rectangle_mini.png" />
        </div>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref } from "vue";
import SafieButton from "@/common/components/SafieButton.vue";
import staticData from "@/static/index";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";
import { ICaseStudy } from "@/static/dataType";
import axios from "axios";
import lottie, { AnimationItem } from "lottie-web";
import lottieData from "@/static/home/data.json";
const lottieRef = ref();

const lottieContext = ref<AnimationItem>();
onMounted(() => {
  lottieContext.value = lottie.loadAnimation({
    container: lottieRef.value,
    autoplay: true,
    animationData: lottieData,
  });
});

onUnmounted(() => {
  lottieContext.value && lottieContext.value.destroy();
});

const { t } = useI18n();
const router = useRouter();
const currenCase = ref(0);
const store = useStore();
const isLogin = computed(() => store.state.isLogin);
const handleChangeCase = (type: string) => {
  if (type === "prev") {
    if (currenCase.value === 0) return false;
    currenCase.value = currenCase.value - 1;
  } else if (type === "next") {
    if (currenCase.value === 3) return false;
    currenCase.value = currenCase.value + 1;
  }
};

const handlerQaItem = (index: number) => {
  let copyPathId = "";
  switch (index) {
    case 0:
      copyPathId = "0-0-0";
      break;
    case 1:
      copyPathId = "1-0-0";
      break;
    case 2:
      copyPathId = "2-0-0";
      break;
    case 3:
      copyPathId = "3-0-0";
      break;
  }
  router.push({
    path: "/faq",
    query: {
      path: copyPathId,
    },
  });
};

const caseData = ref<ICaseStudy[]>();
const caseBaseRoute = "/casestudy/";
axios.get("./static/case.json").then((res) => {
  caseData.value = res.data as ICaseStudy[];
});
const faqData = ref();
axios.get("./static/faq.json").then((res) => {
  faqData.value = res.data;
});
interface IFaqItem {
  category1: string;
  answer: string;
  question: string;
  category2: string;
}
const faqShowData = computed(() => {
  const result: IFaqItem[] = [];
  if (faqData.value) {
    const category1 = faqData.value.category1;
    category1.forEach((category: string) => {
      const faqItem = faqData.value.data.find(
        (item: { category1: string }) => item.category1 === category,
      );
      faqItem && result.push(faqItem);
    });
  }
  return result;
});
const releaseData = ref();
axios.get("./static/release.json").then((res) => {
  releaseData.value = res.data;
});
</script>
<style lang="scss" scoped>
.center {
  margin: 0 auto !important;
}
.home-width {
  max-width: 1120px;
  margin: 0 auto;
}
.home-title {
  line-height: 65px;
  font-size: 36px;
  color: var(--safie-active-text);
  font-weight: 700;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 80px;
}
.home-sub-title {
  font-size: 16px;
  line-height: 28px;
  color: var(--safie-active-text);
  text-align: center;
  margin-bottom: 40px;
}
.tag {
  font-size: 14px;
  color: var(--safie-green-400);
  border: 1px solid var(--safie-green-400);
  border-radius: 4px;
  display: inline-flex;
  height: 30px;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}
.margin-top-64 {
  margin-top: 64px;
}
.home {
  background: #fff;
  width: 100%;
  overflow: hidden;
  .banner {
    height: calc(var(--vh, 1vh) * 100 - 80px);
    background-image: url("../static/home/image/home.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 60% center;
    position: relative;
    .title {
      padding-top: calc(var(--vh, 1vh) * 30);
      color: #fff;
      line-height: 104px;
      font-size: 72px;
      font-weight: 700;
    }
    .des {
      line-height: 30px;
      color: #fff;
      font-weight: 700;
      font-size: 20px;
      margin-bottom: 80px;
    }
    .lottie-box {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 40px;
    }
    .down {
      height: 60px;
    }
  }
  .guide {
    .guide-bg {
      background: #e4f6f7;
      padding: 50px 0px;
    }
    img {
      width: 600px;
      display: block;
      margin: 0 auto;
      margin-bottom: 40px;
    }
    .btn-group {
      width: 520px;
      margin: 0 auto;
    }
  }
  .case {
    .carousel {
      position: relative;
      .carousel-box {
        width: 100%;
        position: relative;
        height: 489px;
        overflow: hidden;
        .flex {
          position: absolute;
        }
        .box {
          width: 346px;
          cursor: pointer;
          margin-right: 40px;
          --title-color: var(--safie-active-text);
          &:hover {
            --title-color: var(--safie-green-400);
            .case-image-box {
              img {
                width: 105%;
                height: 105%;
              }
              .image-hover-mask {
                background-color: rgba(255, 255, 255, 0.3);
              }
            }
          }
          .case-image-box {
            position: relative;
            width: 346.67px;
            height: 212px;
            margin-bottom: 24px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 100%;
              height: 212px;
              transition: all 0.4s linear;
            }
            .image-hover-mask {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              background-color: transparent;
              transition: all 0.4s linear;
            }
          }

          .title {
            color: var(--title-color);
            font-size: 17px;
            line-height: 24px;
            font-weight: 700;
            margin-bottom: 20px;
            height: 96px;
            transition: color 0.4s linear;
          }
          .tag {
            margin-right: 16px;
          }
          .company {
            line-height: 25px;
            color: var(--safie-green-400);
            font-weight: 500;
            margin-top: 16px;
            margin-bottom: 64px;
          }
        }
      }
      .prev {
        position: absolute;
        width: 40px;
        height: 40px;
        left: -20px;
        top: 86px;
        cursor: pointer;
        z-index: 10;
        font-size: 40px;
        color: var(--safie-green-400);
        background: #fff;
        border-radius: 50%;
        line-height: 40px;
        overflow: hidden;
        &:hover {
          transform: scale(1.2);
          transition: transform 0.5s;
        }
      }
      .next {
        z-index: 10;
        position: absolute;
        width: 40px;
        height: 40px;
        right: -20px;
        top: 86px;
        cursor: pointer;
        font-size: 40px;
        color: var(--safie-green-400);
        background: #fff;
        border-radius: 50%;
        overflow: hidden;
        line-height: 40px;
        &:hover {
          transform: scale(1.2);
          transition: transform 0.5s;
        }
      }
    }
  }
  .qa {
    .qa-item {
      --hover-color: var(--safie-active-text);
      cursor: pointer;
      height: 112px;
      border-bottom: 1px solid var(--safie-green-100);
      &:hover {
        --hover-color: var(--safie-green-400);
      }
      .item {
        .ques {
          color: var(--hover-color);
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
          margin-bottom: 20px;
        }
        .tag {
          height: 25px;
        }
      }
      .Safieicon {
        color: var(--safie-green-400);
      }
    }
  }
  .note {
    padding-bottom: 104px;
    .home-title {
      margin-bottom: 44px;
    }
    .note-item {
      margin-bottom: 40px;
      .time-tag {
        margin-bottom: 20px;
        span {
          height: 8px;
          width: 8px;
          border: 4px solid var(--safie-green-400);
          border-radius: 50%;
          margin-right: 27px;
        }
        .time {
          display: inline-flex;
          height: 37px;
          padding: 0 12px;
          background: var(--safie-white-100);
          border-radius: 4px;
          color: var(--safie-active-text);
        }
      }
      :deep(.title) {
        line-height: 28px;
        font-size: 20px;
        color: var(--safie-active-text);
        font-weight: 700;
        margin-bottom: 16px;
        padding-left: 43px;
      }
      :deep(.item) {
        color: #505c58;
        font-size: 16px;
        line-height: 28px;
        display: flex;
        align-items: flex-start;
        padding-left: 43px;
        span {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          border: 1px solid #505c58;
          display: block;
          margin-right: 8px;
          margin-top: 10px;
        }
        div {
          flex: 1;
        }
      }
    }
  }
  .banner-10th {
    padding-bottom: 104px;
    text-align: center;
    .sp {
      display: none !important;
    }
    .pc {
      display: block !important;
    }
  }
}
@media screen and (max-width: 1120px) {
  .home-width {
    margin: 0 64px;
  }
}
@media screen and (max-width: 640px) {
  .home-width {
    margin: 0 16px;
  }
  .home-title {
    line-height: 34px;
    font-size: 24px;
    margin-bottom: 16px;
    margin-top: 40px;
  }
  .home-sub-title {
    font-size: 14px;
    line-height: 25px;
    margin-bottom: 40px;
    padding: 0 16px;
  }
  .margin-top-64 {
    margin-top: 40px;
  }
  .home {
    .banner {
      .title {
        padding-top: calc(var(--vh, 1vh) * 25);
        line-height: 64px;
        font-size: 36px;
      }
      .des {
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 24px;
      }
      .down {
        margin-top: 158px;
      }
    }
    .guide {
      .guide-bg {
        padding: 24px 16px;
      }
      img {
        width: 100%;
      }
      .btn-group {
        width: 240px;
        flex-direction: column;
      }
      .el-button + .el-button {
        margin-left: 0;
        margin-top: 40px;
      }
    }
    .case {
      .carousel {
        .carousel-box {
          height: auto;
          .flex {
            position: relative;
            flex-direction: column;
            left: 0 !important;
          }
          .box {
            width: 100%;
            margin-right: 0;
            &:hover {
              --title-color: var(--safie-active-text);
              .case-image-box {
                img {
                  width: 100%;
                  height: auto;
                }
                .image-hover-mask {
                  background-color: transparent;
                }
              }
            }
            .case-image-box {
              width: 100%;
              height: auto;
              img {
                width: 100%;
                height: auto;
              }
              &:hover {
                img {
                  width: 100%;
                  height: auto;
                }
              }
            }
            .title {
              height: auto;
            }
            .company {
              margin-bottom: 40px;
            }

            &:nth-child(n + 4) {
              display: none;
            }
          }
        }
        .prev {
          display: none;
        }
        .next {
          display: none;
        }
      }
    }
    .qa {
      .qa-item {
        .item {
          .ques {
            font-size: 15px;
            line-height: 22px;
          }
        }
      }
    }
    .note {
      padding-bottom: 64px;
      .home-title {
        margin-bottom: 40px;
      }
      .note-item {
        margin-bottom: 40px;
      }
    }
    .banner-10th {
      padding-bottom: 64px;
      text-align: center;
      .sp {
        display: block !important;
      }
      .pc {
        display: none !important;
      }
    }
  }
}
</style>
